import React from 'react';
import { useNavigate } from 'react-router-dom';
const DEPTS = [
  { name: 'Produce', icon: '\uD83E\uDD66', items: 284, revenue: '$8,420', margin: '42%', path: '/produce', staff: 6 },
  { name: 'Deli Counter', icon: '\uD83E\uDD69', items: 156, revenue: '$5,890', margin: '38%', path: '/deli-counter', staff: 4 },
  { name: 'Bakery', icon: '\uD83C\uDF5E', items: 92, revenue: '$3,240', margin: '55%', path: '/bakery', staff: 3 },
  { name: 'Meat & Seafood', icon: '\uD83E\uDD53', items: 128, revenue: '$12,650', margin: '28%', path: '/meat-seafood', staff: 5 },
  { name: 'Dairy', icon: '\uD83E\uDD5B', items: 210, revenue: '$6,780', margin: '32%', path: null, staff: 3 },
  { name: 'Frozen', icon: '\u2744\uFE0F', items: 340, revenue: '$4,120', margin: '35%', path: null, staff: 2 },
  { name: 'Beverages', icon: '\uD83E\uDDC3', items: 420, revenue: '$5,430', margin: '40%', path: null, staff: 2 },
  { name: 'Household', icon: '\uD83E\uDDF9', items: 580, revenue: '$3,890', margin: '45%', path: null, staff: 2 },
];
export default function DepartmentsPage() {
  const navigate = useNavigate();
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Departments</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Overview of all store departments</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
        {DEPTS.map((d, i) => (
          <div key={i} onClick={() => d.path && navigate(d.path)} style={{ padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', cursor: d.path ? 'pointer' : 'default', transition: 'border-color 0.2s' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 28 }}>{d.icon}</span>
                <div>
                  <div style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700 }}>{d.name}</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>{d.items} products &middot; {d.staff} staff</div>
                </div>
              </div>
              {d.path && <span style={{ color: 'var(--text-muted)', fontSize: 18 }}>&rarr;</span>}
            </div>
            <div style={{ display: 'flex', gap: 16 }}>
              <div><div style={{ color: 'var(--text-muted)', fontSize: 10, textTransform: 'uppercase', fontWeight: 600 }}>Revenue Today</div><div style={{ color: '#16A34A', fontSize: 16, fontWeight: 700 }}>{d.revenue}</div></div>
              <div><div style={{ color: 'var(--text-muted)', fontSize: 10, textTransform: 'uppercase', fontWeight: 600 }}>Margin</div><div style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700 }}>{d.margin}</div></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
